<template>
  <div id="app">
    <head-Back title="常见问题"></head-Back>
    <div class="cheat-img" @click="toCheat()">

    </div>
    <div class="question-ones" v-for="item in questions">
      <div class="questions-ones-title">{{item.name}}</div>
      <div class="question-one" v-for="q in item.list">
        <div class="question-one-title" @click="show(q)" v-if="qu.title != q.title">
          {{q.title}}
          <div class="question-one-close"></div>
        </div>

        <div class="question-one-title" @click="show(q)" v-if="qu.title == q.title">
          {{q.title}}
          <div class="question-one-button"></div>
        </div>
        <div class="question-one-desc" v-if="qu.title == q.title" v-html="q.desc"></div>
      </div>
    </div>
     <div class="qa" @click="toqa()"></div>

  </div>
</template>
<script>
import headBack from "../common/head-back";

export default {
  metaInfo: {
    title: "常见问题"
  },
  name: "app",
  data() {
    return {
      msg: "常见问题",
      questions: [
        {
          name:"关于官网",
          list:[
             {
              title: "好运吧的官网是？",

              desc: "好运吧的官网地址是：http://www.haoyunba.com"
            },
          ]
        },
        { 
          name: "关于账号密码",
          list: [
            {
              title: "如何注册好运吧？",
              desc:
                "打开好运吧官网http://www.haoyunba.com,点击注册按钮<br/>注册流程：输入大陆手机号→填写图形验证码→获取短信验证码→注册成功<br/>每个手机号只可注册一个账号，不支持修改手机号"
            },
            {
              title: "好运吧账号与聊天号的关系",
              desc:
                "一个好运吧账号有十个聊天号（相当于有10个微信号），每个聊天号有各自对应的密码，互相独立，互不影响。<br/>好运吧的登录形式是：注册手机号+验证码<br/>聊天号的登录形式是：好运吧的注册手机号+聊天号密码"
            },
            {
              title: "忘记聊天号的密码怎么办？",
              desc:
                "每个账号下，十个聊天号的密码不可相同，产品不设密码找回，所以请您牢记密码。"
            }
          ]
        },
        {
          name: "关于客服",
          list: [
            {
              title: "聊天号中客服的联系方式",
              desc:
                "每个聊天号都有三个默认客服号：<br/>定制客服号码：10000<br/>反馈客服号码：10001<br/>投诉客服号码：10002<br/>在对应客服的对话框中发送你的问题，会有客服处理。<br/>客服的服务时间：北京时间，周一至周五，10:00~18:00（社会特殊情况及法定节假日除外）"
            },
             {
              title: "客服的微信联系方式",
              desc:
                "客服的微信号码：haoyunbakefu<br />通过微信添加客服的微信号为微信好友，会有客服通过微信沟通处理各种问题。<br />客服的服务时间：北京时间，周一至周五，10:00~18:00（社会特殊情况及法定节假日除外）"
            },
            {
              title: "什么是私人定制？",
              desc:
                "私人定制是指：为您提供个性化的服务。<br/>您想要的APP外壳、名称、图标，以及其他您想要的功能均可联系客服定制，客服号10000；<br/>联系步骤：登录某个聊天号——找到10000定制客服——发送自己的需求，将有专属客服与您联系。"
            }
          ]
        },
        {
          name: "关于伪装",
          list: [
            {
              title: "什么是伪装外壳？",
              desc:
                "好运吧平台下，有许多套着伪装外壳的聊天APP。我们把聊天APP伪装成计算器、新闻资讯、学习、办公等常见APP，平时可正常使用这些APP的功能，但在输入特定密码之后，就进入私密聊天界面。"
            },
            {
              title: "什么是消息通知伪装？",
              desc:
                "使用伪装APP后，表面上看起来是收到一条消息新闻热点提示，或者版本更新等普通的通知，实际上是伪装APP有人给你发聊天信息，只要输入特定密码即可进入聊天界面查看；这就是消息通知伪装。<br/>同时，不同的伪装APP会配有对应的伪装提醒。例如：选择的伪装外壳是新闻资讯，当收到新消息时会推送一条新闻提示；选择的伪装外壳是计算器，当收到新消息时会推送一条版本更新提示等。<br /> 同时，不同的伪装APP会配有对应的伪装提醒。例如：选择的伪装外壳是新闻资讯，当收到新消息时会推送一条新闻提示；选择的伪装外壳是计算器，当收到新消息时会推送一条版本更新提示等。"
            },
            {
              title: "紧急情况，如何快速伪装？",
              desc:
                "当您使用聊天界面时遇到紧急情况，可通过以下方式快速返回伪装外壳。<br/>1、点击页面悬浮按钮一键返回；点击首页左上角【设置】-打开【显示返回浮窗】功能即可使用；<br/>2、向下翻转手机，使手机背面朝下即可返回；点击首页左上角【设置】-打开【翻转返回】功能即可；<br/>3、若你使用伪装APP聊天时时，进行以下任意操作：(1)把手机锁屏、(2)切换至别的应用、(3)直接退到手机桌面，当再次打开时伪装APP时，显示的是伪装界面。"
            }
          ]
        },
        {
          name: "关于伪装设置",
          list: [
            {
              title: "什么是【显示返回浮窗】功能？",
              desc:
                "【显示返回浮窗】功能打开后，在首页、我的、通讯录页面左下角都有一个“返回按钮”，当你在伪装APP聊天时，有人靠近或者突然有紧急情况，只要点击这个按钮，即可返回伪装外壳，避免被人发现。<br/>设置入口：【首页】左上角-【设置】页面-显示返回浮窗开关；"
            },
            {
              title: "什么是【需要伪装外壳】功能？",
              desc:
                "【需要伪装外壳】功能打开后，当你从手机桌面点击这个APP后，会先进入伪装页面（比如计算器页面），需要在伪装页面输入特定密码才可进入聊天界面；若这个功能关闭，当你从手机桌面点击这个APP后，直接进入聊天界面。<br/>设置入口：【首页】左上角-【设置】页面-需要伪装设置开关功能；"
            },
            {
              title: "什么是【自动返回】功能？",
              desc:
                "【自动返回】功能打开后，你可以自由设置时间。若你设置了1分钟，则当你在1分钟内没有操作APP页面，它会自动返回伪装页面；有效避免酒后泄露隐私。<br/>设置入口：【首页】左上角-【设置】页面-自动返回功能；"
            },

            {
              title: "什么是【保密时段】功能？",
              desc:
                "【保密时段】功能打开后，你可以设置一个保密时间段；若你设置了17:00-22:00为保密时段，则每天在这个时间段内，任何人打开APP只能看到伪装页面，无法进入聊天界面，输入特定密码也不会有任何效果。时间非保密时段内，APP恢复正常使用。<br />设置入口：【首页】左上角-【设置】页面-保密时段功能；"
            },
            {
              title: "什么是【翻转返回】功能？",
              desc:
                "【翻转返回】功能打开后，若你在跟好友私聊时，遇到紧急情况，只需要把手机翻回来，反面朝上，聊天界面秒变伪装页面。一面伪装，无声无息。<br/>设置入口：【首页】左上角-【设置】页面-翻转返回功能；"
            }
          ]
        },
        {
          name: "关于聊天记录",
          list: [
            {
              title: "什么是【同步聊天记录】功能？",
              desc:
                "【同步聊天记录】功能打开后，你可以选择同步时间，近3天、近1年、近2年。即使更换手机，也可以在新的APP使用该功能找回聊天记录。切记：已删除的聊天记录无法恢复。<br/>设置入口：【首页】左上角-【设置】【伪装设置】页面-同步聊天记录功能；"
            }
          ]
        },

        {
          name: "关于APP的使用",
          list: [
            {
              title: "如何添加好友？",
              desc:
                "有三个方式添加好友：<br/>1、在【通讯录】-【添加好友】-点击搜索框，输入对方聊天号，即可搜索出对方的名片，点击添加好友即可发送添加好友请求；<br/>2、在【通讯录】页面的右上角-【扫一扫】扫描对方的亲密聊名片二维码，发送添加请求；名片二维码在【我的】-【我的二维码】<br/>3、在群聊中，点击对方头像-进入对方名片-发送添加请求；"
            },
            {
              title: "如何设置聊天背景？",
              desc:
                "在与某好友的聊天页面-点击右上角【...】-点击【聊天详情】-选择【设置聊天背景】<br/>选择“仅为自己更换“，更换的是我自己的；<br/>选择“我和好友一起更换”更换的是我和好友两人的；<br/>选择“恢复默认设置”则背景变成白色，之前的背景设置都失效。"
            }
          ]
        },
        {
          name: "关于黑名单",
          list: [
            {
              title: "如何将ta加入黑名单？",

              desc: "如何将ta加入黑名单？",
              desc:
                "如何将某人加入黑名单：在与某好友的聊天页面-点击右上角【...】进入聊天详情页面-选择【加入黑名单】即可；<br/>将某好友加入黑名单后，双方无法发送和接收对方的任何信息。"
            },
            {
              title: "如何将ta移出黑名单？",
              desc:
                "如何将某人从黑名单中移除：在【我的】页面点击顶部入口-选择【黑名单管理】-再列表中选择某个好友，点击移除黑名单即可；<br/>在黑名单列表中移除某好友后，双方的通讯等沟通均回复正常；"
            }
          ]
        },
        {
          name: "其他",
          list: [
           
            {
              title: "关于隐私",
              desc:
                "1、我们仅支持通过聊天号添加好友 <br /> 注册完成后，我们会生成您的专属聊天号，仅能通过聊天号添加好友。通过手机号、昵称等其他条件无法查找到。这能确保了交流的私密性。<br />" +
                "2、不收集与匹配通讯录，不用担心别人知道你在用伪装APP <br /> 我们不收集您的通讯录，这样就不会通过社交关系向你推荐好友。你的好友也不会知道你正在使用伪装APP。"
            },
            {
                   title: "好运吧的官网是？",
                   desc:"好运吧的官网地址是：http://www.haoyunba.com"
            }
          ]
        }
      ],
      qu: {
        title: "如何注册好运吧？",
        desc:
          "打开好运吧官网http://www.haoyunba.com,点击注册按钮注册流程：输入大陆手机号→填写图形验证码→获取短信验证码→注册成功每个手机号只可注册一个账号，不支持修改手机号"
      }
    };
  },
  methods: {
    show(a) {
      console.log("关闭");
      if (this.qu.title == a.title) {
        this.qu = { title: "", desc: "" };
      } else {
        this.qu = a;
      }
    },
    toCheat(){
      this.$router.push("/cheat");
      // this.$router.push("/pay");
    },
    toqa: function() {
      this.$router.push("/noviceGuide");
    }
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
#app {
  width: 750px;
  height: auto;
  background: rgba(237, 237, 237, 1);
}

.question-ones {
  width: 750px;
  height: auto;
  
}

.questions-ones-title {
  width: 99px;
  height: 23px;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(114, 114, 114, 1);
  text-align: left;
  width: 682px;
  margin: 67px auto 30px;
}
.question-one {
  width: 100%;
  background: white;
}

.question-one-button {
  background: url("./img/open.png");
  width: 27px;
  height: 17px;
  position: relative;
  background-size: 100% 100%;
  border: none;
  line-height: 100px;
  float: right;
  margin-right: 37px;
  margin-top: 37px;
}

.question-one-close {
  background: url("./img/close.png");
  width: 17px;
  height: 27px;
  position: relative; 
  background-size: 100% 100%;
  border: none;
  float: right;
  margin-right: 37px;
  margin-top: 37px;
}

.question-one-title {
  margin-left: 34px;
  height: 100px;
  width: 716px;
  border-bottom: 1px solid rgba(237, 237, 237, 1);
  text-align: left;
  line-height: 100px;
}
.question-one-desc {
  margin: 30px 0 0px 34px;
  padding: 0 30px 30px 0;
  height: auto;
  width: 670px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(179, 179, 179, 1);
  line-height: 39px;
  text-align: left;
  line-height: 60px;
  background: white;
  border-bottom: 1px solid rgba(237, 237, 237, 1);
}
.cheat-img{
  width: 690px;
  height: 200px;
  background: url("./img/cheat.png");
  background-size: 100% 100%;
  margin: 40px auto 0 auto;
}

.qa {
  background: url("./img/new-guide.png");
  background-size: 100% 100%;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  position: fixed;
  bottom: 130px;
  margin-left: 10px;

}


</style>


// WEBPACK FOOTER //
// src/components/clac/question.vue